export default __webpack_public_path__ + "static/media/dane.db9ccd10.png";